<script lang="ts">
</script>

<div class="filter">
    <slot />
</div>

<style>
    .filter {
        display: flex;
        flex-direction: row;
        align-items: center;
        /*padding: 0 1rem;*/
        padding: 2px 0 2px 0;
        border: 1px solid var(--color-gray-300);
        border-radius: 0.5rem;
        column-gap: 10px;
    }
</style>